export const panes = [{'menuItem': 'Datos de la zona'}, {'menuItem': 'Ubicaciones'}];

export const PANES_INDICES = {
  'ZONE_DATA': 0,
  'LOCATIONS_DATA': 1,
};
